<template>
  <div class="col-12" v-if="contract != null && Object.keys(contract).length > 0">
    <div class="status-docusign mb-1">
      <div class="row">
        <div class="col">
          <i class="bi bi-file-earmark-text-fill"></i>
          {{ title }} - {{ contract.metadata?.financialInstitution || 'Instituição não informada' }}
        </div>
        <div v-if="contract.status === 'COMPLETED'" class="col row g-2 float-end docusign-button">
          <form-button
            class="col-6 form-input"
            title="Contrato"
            :loading="loadingOpenDocusign[contract.id]"
            :isDisabled="loadingOpenDocusign[contract.id]"
            @clicked="openDocusign(contract)"
          />

          <form-button
            class="col-6 form-input"
            title="Certificado"
            :loading="loadingOpenCertificate[contract.id]"
            :isDisabled="loadingOpenCertificate[contract.id]"
            @clicked="openDocusignCertificate(contract)"
          />
        </div>
      </div>
      <div class="row">
        <p>
          {{ contract.signerName || 'Nome não informado' }} -
          {{ contract.signerEmail || 'Email não informado' }}
          <span
            class="float-end text-end"
            :style="{ color: docusignStatus[contract.status]?.color || 'black' }"
          >
            {{ docusignStatus[contract.status]?.name || 'Status desconhecido' }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { useDocusign } from '@shared/composables/useDocusign'
import { docusignStatus } from '@shared/composables/useGlobalConfig'
import { formButton } from 'tb-design_system-web'

export default {
  components: {
    formButton
  },
  props: {
    contract: {
      type: Object,
      default: () => ({}),
      required: true
    },
    title: {
      type: String,
      default: 'Contrato de câmbio'
    }
  },

  setup() {
    const { openDocusign, loadingOpenDocusign, loadingOpenCertificate, openDocusignCertificate } =
      useDocusign()

    return {
      docusignStatus,

      openDocusign,
      loadingOpenDocusign,
      loadingOpenCertificate,
      openDocusignCertificate
    }
  }
}
</script>

<style lang="scss">
.docusign-button {
  margin-top: 0;

  .form-input {
    margin-top: 0;

    button {
      height: 35px;
      margin-top: 0;

      .goo2 {
        margin-top: -25px;
        transform: scale(0.7);
      }
    }
  }
}
</style>
